import { useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { IonGrid, IonRow, IonCol, IonLabel, IonSegment, IonSegmentButton, IonButton, IonIcon } from '@ionic/react';
import { closeOutline, addCircleOutline, swapVertical } from 'ionicons/icons';
import { Storage } from '@capacitor/storage';
import { CheckObject } from '../../defines/Functions';
import FlightAirport from './modals/FlightAirport';
import FlightPassengerModal from './modals/FlightPassenger';
import MyDatepicker from '../MyDatepicker';
interface Props {
    data: any
}

const Flight = (props: Props) => {
    let flightJson = {} as any;
    const [state, setState] = useState({
        segValue: "oneway",
        multipleItemsCount: 2,
        flightOriginValue: {} as any,
        flightDestinationValue: {} as any,
        flightPassengerValue: ["Economy", "1", "0", "0"] as any,
        flightMultipleOriginValues: [] as any,
        flightMultipleDestinationValues: [] as any,
        datepickerValue: [] as any,
        datepickerMultipleValues: [] as any,
    })
    const [required, setRequired] = useState({
        origin: false,
        destination: false,
        date: false,
        multipleOrigin: [false, false],
        multipleDestination: [false, false],
        multipleDate: [false, false]
    });
    const datepickerMinDate = useRef<any>([]);
    const titleSwitch = (index: number) => {
        let title = "";
        switch (index) {
            case 0:
                title = "پرواز اول";
                break;
            case 1:
                title = "پرواز دوم";
                break;
            case 2:
                title = "پرواز سوم";
                break;
            case 3:
                title = "پرواز چهارم";
                break;
            case 4:
                title = "پرواز پنجم";
                break;
        }
        return title;
    }
    const addMultipleItems = () => {
        if (state.multipleItemsCount <= 5) {
            setState({ ...state, multipleItemsCount: state.multipleItemsCount + 1 });
            required.multipleOrigin.push(false);
            required.multipleDestination.push(false);
            required.multipleDate.push(false);
        }
    }
    const removeMultipleItems = (index: number) => {
        state.flightMultipleOriginValues.splice(index, 1);
        state.flightMultipleDestinationValues.splice(index, 1);
        setState({ ...state, flightMultipleOriginValues: state.flightMultipleOriginValues, flightMultipleDestinationValues: state.flightMultipleDestinationValues });
        setState({ ...state, multipleItemsCount: state.multipleItemsCount - 1 });
        required.multipleOrigin.splice(index, 1);
        required.multipleDestination.splice(index, 1);
        required.multipleDate.splice(index, 1);
    }
    const handleOriginCallback = (childData: any) => {
        let childDataObj = JSON.parse(childData);
        let indexedState = state.flightMultipleOriginValues;
        if (typeof childDataObj.multipleIndex !== "undefined") {
            indexedState[childDataObj.multipleIndex] = childDataObj;
            setState({ ...state, flightMultipleOriginValues: indexedState });
            let multipleOriginRequired = required.multipleOrigin;
            multipleOriginRequired[childDataObj.multipleIndex] = false;
            setRequired({ ...required, multipleOrigin: multipleOriginRequired });
        } else {
            setState({ ...state, flightOriginValue: childDataObj });
            setRequired({ ...required, origin: false });
        }
    }
    const handleDestinationCallback = (childData: any) => {
        let childDataObj = JSON.parse(childData);
        let indexedState = state.flightMultipleDestinationValues;
        if (typeof childDataObj.multipleIndex !== "undefined") {
            indexedState[childDataObj.multipleIndex] = childDataObj;
            setState({ ...state, flightMultipleDestinationValues: indexedState });
            let multipleDestinationRequired = required.multipleDestination;
            multipleDestinationRequired[childDataObj.multipleIndex] = false;
            setRequired({ ...required, multipleDestination: multipleDestinationRequired });
        } else {
            setState({ ...state, flightDestinationValue: childDataObj });
            setRequired({ ...required, destination: false });
        }
    }
    const handlePassengerCallback = (childData: any) => {
        childData = childData.split(',');
        setState({ ...state, flightPassengerValue: childData });
    }
    const handleDatepickerCallback = (childDataObj: any) => {
        let indexedState = state.datepickerMultipleValues;
        Array.from(Array(state.multipleItemsCount)).forEach((_, index) => {
            if (index > childDataObj.multipleIndex) {
                if (state.datepickerMultipleValues[index]) {
                    state.datepickerMultipleValues[index].dates = childDataObj.dates;
                    state.datepickerMultipleValues[index].datesJalali = childDataObj.datesJalali;
                    state.datepickerMultipleValues[index].datesJalaliFormatted = childDataObj.datesJalaliFormatted;
                    state.datepickerMultipleValues[index].isJalali = childDataObj.isJalali;
                }
            }
        })
        if (typeof childDataObj.multipleIndex !== "undefined") {
            indexedState[childDataObj.multipleIndex] = childDataObj;
            setState({ ...state, datepickerMultipleValues: indexedState });
            let multipleDateRequired = required.multipleDate;
            multipleDateRequired[childDataObj.multipleIndex] = false;
            setRequired({ ...required, multipleDate: multipleDateRequired });
        } else {
            setState({ ...state, datepickerValue: childDataObj });
            setRequired({ ...required, date: false });
        }
    }
    flightJson = {
        passengers: {
            "adults": parseInt(state.flightPassengerValue[1]),
            "childs": parseInt(state.flightPassengerValue[2]),
            "infants": parseInt(state.flightPassengerValue[3]),
        },
        other: {
            "trip": state.segValue,
            "cabin": state.flightPassengerValue[0],
            "isJalali": state.datepickerValue.isJalali === 'true' ? true : false
        },
        routes: [] as any,
    }
    if (state.segValue === 'multiple') {
        Array.from(Array(state.multipleItemsCount)).forEach((_, index) => {
            if (state.flightMultipleOriginValues[index] && state.flightMultipleDestinationValues[index] && state.datepickerMultipleValues[index]) {
                const objItem = {
                    from: state.flightMultipleOriginValues[index],
                    to: state.flightMultipleDestinationValues[index],
                    dates: {
                        "departure": state.datepickerMultipleValues[index].dates,
                        "departureJalali": state.datepickerMultipleValues[index].datesJalali,
                        "departureJalaliFormatted": state.datepickerMultipleValues[index].datesJalaliFormatted
                    }
                }
                flightJson.routes.push(objItem);
            }
            if (state.datepickerMultipleValues[index]) {
                datepickerMinDate.current[index + 1] = state.datepickerMultipleValues[index].dates;
            }
        })
    } else {
        const objItem = {
            from: state.flightOriginValue,
            to: state.flightDestinationValue,
            dates: {
                "departure": state.datepickerValue.dates ? state.datepickerValue.dates[0] : null,
                "arrival": state.datepickerValue.dates ? (state.segValue !== 'oneway' ? state.datepickerValue.dates[1] : null) : null,
                "departureJalali": state.datepickerValue.dates ? state.datepickerValue.datesJalali[0] : null,
                "arrivalJalali": state.datepickerValue.dates ? (state.segValue !== 'oneway' ? state.datepickerValue.datesJalali[1] : null) : null,
                "departureJalaliFormatted": state.datepickerValue.dates ? state.datepickerValue.datesJalaliFormatted[0] : null,
                "arrivalJalaliFormatted": state.datepickerValue.dates ? (state.segValue !== 'oneway' ? state.datepickerValue.datesJalaliFormatted[1] : null) : null
            }
        }
        flightJson.routes.push(objItem);
    }
    const setFlightJson = async () => {
        await Storage.set({
            key: 'flightJson',
            value: JSON.stringify(flightJson),
        });
    };
    const clearFlightJson = async () => {
        await Storage.remove({ key: 'flightJson' });
    };
    const history = useHistory();
    const didGetFlightJson = useRef(false);
    useEffect(() => {
        if (!didGetFlightJson.current) {
            const getFlightJson = async () => {
                const { value } = await Storage.get({ key: 'flightJson' });
                if (value !== null) {
                    const objectValue = JSON.parse(value);
                    let multipleOrigins = [] as any;
                    let multipleDestinations = [] as any;
                    let datepickerValues = {
                        dates: [],
                        datesJalali: [],
                        datesJalaliFormatted: []
                    } as any;
                    let savedSegValue = 'oneway';
                    let datepickerValuesMultiple = [] as any;
                    if (objectValue.routes.length) {
                        if (objectValue.other.trip !== 'multiple') {
                            datepickerValues.dates.push(objectValue.routes[0].dates.departure);
                            datepickerValues.datesJalali.push(objectValue.routes[0].dates.departureJalali);
                            datepickerValues.datesJalaliFormatted.push(objectValue.routes[0].dates.departureJalaliFormatted);
                            if (objectValue.other.trip === 'roundtrip') {
                                datepickerValues.dates.push(objectValue.routes[0].dates.arrival);
                                datepickerValues.datesJalali.push(objectValue.routes[0].dates.arrivalJalali);
                                datepickerValues.datesJalaliFormatted.push(objectValue.routes[0].dates.arrivalJalaliFormatted);
                                savedSegValue = 'roundtrip';
                            }
                        } else {
                            savedSegValue = 'multiple';
                            objectValue.routes.forEach((route: any, key: number) => {
                                let item = {
                                    dates: [route.dates.departure[0]],
                                    datesJalali: [route.dates.departureJalali[0]],
                                    datesJalaliFormatted: [route.dates.departureJalaliFormatted[0]],
                                    multipleIndex: key
                                };
                                datepickerValuesMultiple.push(item);
                            })
                        }

                        objectValue.routes.forEach((route: any) => {
                            multipleOrigins.push(route.from);
                            multipleDestinations.push(route.to);
                        })
                        setState({
                            ...state,
                            segValue: savedSegValue,
                            flightOriginValue: objectValue.routes[0].from,
                            flightDestinationValue: objectValue.routes[0].to,
                            flightMultipleOriginValues: multipleOrigins,
                            flightMultipleDestinationValues: multipleDestinations,
                            flightPassengerValue: [objectValue.other.cabin, objectValue.passengers.adults, objectValue.passengers.childs, objectValue.passengers.infants],
                            datepickerValue: datepickerValues,
                            datepickerMultipleValues: datepickerValuesMultiple
                        });
                        // }
                    }
                }
            };
            getFlightJson();
            didGetFlightJson.current = true;
        }
    }, [props, state]);
    const onSearchCLick = () => {
        let isRequired = false;
        if (state.segValue !== 'multiple') {
            if (CheckObject(state.flightOriginValue)) {
                setRequired(prevRequired => { return { ...prevRequired, origin: true } });
                isRequired = true;
            }
            if (CheckObject(state.flightDestinationValue)) {
                setRequired(prevRequired => { return { ...prevRequired, destination: true } });
                isRequired = true;
            }
            if (state.datepickerValue.length === 0) {
                setRequired(prevRequired => { return { ...prevRequired, date: true } });
                isRequired = true;
            }
        } else {
            required.multipleOrigin.forEach((v: any, k: number) => {
                if (typeof state.flightMultipleOriginValues[k] === "undefined" || !state.flightMultipleOriginValues[k]) {
                    let multipleOriginRequired = required.multipleOrigin;
                    multipleOriginRequired[k] = true;
                    setRequired(prevRequired => { return { ...prevRequired, multipleOrigin: multipleOriginRequired } });
                    isRequired = true;
                }
            })
            required.multipleDestination.forEach((v: any, k: number) => {
                if (typeof state.flightMultipleDestinationValues[k] === "undefined" || !state.flightMultipleDestinationValues[k]) {
                    let multipleDestinationRequired = required.multipleDestination;
                    multipleDestinationRequired[k] = true;
                    setRequired(prevRequired => { return { ...prevRequired, multipleDestination: multipleDestinationRequired } });
                    isRequired = true;
                }
            })
            required.multipleDate.forEach((v: any, k: number) => {
                if (typeof state.datepickerMultipleValues[k] === "undefined" || !state.datepickerMultipleValues[k]) {
                    let multipleDateRequired = required.multipleDate;
                    multipleDateRequired[k] = true;
                    setRequired(prevRequired => { return { ...prevRequired, multipleDate: multipleDateRequired } });
                    isRequired = true;
                }
            })
        }
        if (!isRequired) {
            clearFlightJson();
            setFlightJson();
            history.push({
                pathname: '/search/flight',
                search: '?type=' + state.segValue
            });
        }

    }
    const onSegmentChange = (e: any) => {
        setState({ ...state, segValue: e });
    }
    const swapValue = (index?: any) => {
        let swapFlightMultipleOriginValues = state.flightMultipleOriginValues;
        let swapFlightMultipleDestinationValues = state.flightMultipleDestinationValues;
        let from = state.flightMultipleOriginValues[index];
        let to = state.flightMultipleDestinationValues[index];
        swapFlightMultipleOriginValues[index] = to;
        swapFlightMultipleDestinationValues[index] = from;
        setState({
            ...state,
            flightOriginValue: state.flightDestinationValue,
            flightDestinationValue: state.flightOriginValue,
            flightMultipleOriginValues: swapFlightMultipleOriginValues,
            flightMultipleDestinationValues: swapFlightMultipleDestinationValues
        });
    }
    return (
        <IonGrid>
            <IonRow>
                <IonCol size="12">
                    <IonSegment mode="ios" onIonChange={e => onSegmentChange(e.detail.value!)} value={state.segValue}>
                        <IonSegmentButton value="roundtrip">
                            <IonLabel>رفت و برگشت</IonLabel>
                        </IonSegmentButton>
                        <IonSegmentButton value="oneway">
                            <IonLabel>فقط رفت</IonLabel>
                        </IonSegmentButton>
                        <IonSegmentButton value="multiple">
                            <IonLabel>چند مسیری</IonLabel>
                        </IonSegmentButton>
                    </IonSegment>
                </IonCol>
                <IonCol size="12">
                    {state.segValue !== 'multiple' ? (
                        <div className="form-input-container">
                            <IonRow>
                                <IonCol size="12">
                                    <IonLabel>
                                        مبدا پرواز
                                        {required.origin ? <span className="required">الزامی</span> : null}
                                    </IonLabel>
                                    <FlightAirport type="origin" section="flight" flightAirportParentCallback={handleOriginCallback} itemValue={state.flightOriginValue.title} />
                                </IonCol>
                                <IonCol size="12" className="destination-input">
                                    <span className="source-destinatin-swap-btn" onClick={swapValue}>
                                        <IonIcon icon={swapVertical} />
                                    </span>
                                    <IonLabel>
                                        مقصد پرواز
                                        {required.destination ? <span className="required">الزامی</span> : null}
                                    </IonLabel>
                                    <FlightAirport type="destination" section="flight" flightAirportParentCallback={handleDestinationCallback} itemValue={state.flightDestinationValue.title} />
                                </IonCol>
                                {state.segValue === 'oneway' ?
                                    <IonCol size="12">
                                        <IonLabel>
                                            تاریخ رفت
                                            {required.date ? <span className="required">الزامی</span> : null}
                                        </IonLabel>
                                        <MyDatepicker
                                            value={state.datepickerValue && state.datepickerValue.dates && new Date(state.datepickerValue.dates[0])}
                                            isGregorian={state.datepickerValue.isJalali === undefined ? false : state.datepickerValue.isJalali === 'true' ? false : true}
                                            isRange={false}
                                            datepickerParentCallback={handleDatepickerCallback}
                                        />
                                    </IonCol>
                                    :
                                    <IonCol size="12">
                                        <IonLabel>
                                            تاریخ رفت / برگشت
                                            {required.date ? <span className="required">الزامی</span> : null}
                                        </IonLabel>
                                        <MyDatepicker
                                            value={state.datepickerValue && state.datepickerValue.dates && [new Date(state.datepickerValue.dates[0]), new Date(state.datepickerValue.dates[1])]}
                                            isGregorian={state.datepickerValue.isJalali === undefined ? false : state.datepickerValue.isJalali === 'true' ? false : true}
                                            isRange={true}
                                            datepickerParentCallback={handleDatepickerCallback}
                                        />
                                    </IonCol>
                                }
                                <IonCol size="12">
                                    <IonLabel>مسافران و کلاس پروازی</IonLabel>
                                    <FlightPassengerModal flightPassengerParentCallback={handlePassengerCallback} />
                                </IonCol>
                                <IonCol size="12">
                                    <IonButton color="warning" expand="block" className="form-submit-button" onClick={onSearchCLick}>
                                        جستجو
                                    </IonButton>
                                </IonCol>
                            </IonRow>
                        </div>
                    ) : (
                        <div className="form-multiple-input-container">
                            {[...Array(state.multipleItemsCount)].map((_, index) =>
                                <IonRow className="form-multiple-item" key={'index' + index}>
                                    {state.multipleItemsCount === index + 1 ? (
                                        <span className="form-multiple-item-remove-btn" onClick={() => removeMultipleItems(index)} style={{ display: index < 2 ? 'none' : '' }}>
                                            <IonIcon icon={closeOutline} />
                                        </span>
                                    ) : (
                                        null
                                    )}
                                    <IonCol size="12">
                                        <h6>
                                            {titleSwitch(index)}
                                        </h6>
                                    </IonCol>
                                    <IonCol size="12">
                                        <IonLabel>
                                            مبدا پرواز
                                            {required.multipleOrigin[index] ? <span className="required">الزامی</span> : null}
                                        </IonLabel>
                                        <FlightAirport
                                            type="origin"
                                            section="flight"
                                            flightAirportParentCallback={handleOriginCallback}
                                            multipleIndex={index}
                                            itemValue={(state.flightMultipleOriginValues.length && state.flightMultipleOriginValues[index] !== undefined) && state.flightMultipleOriginValues[index].title}
                                        />
                                    </IonCol>
                                    <IonCol size="12" className="destination-input">
                                        <span className="source-destinatin-swap-btn" onClick={() => swapValue(index)}>
                                            <IonIcon icon={swapVertical} />
                                        </span>
                                        <IonLabel>
                                            مقصد پرواز
                                            {required.multipleDestination[index] ? <span className="required">الزامی</span> : null}
                                        </IonLabel>
                                        <FlightAirport
                                            type="destination"
                                            section="flight"
                                            flightAirportParentCallback={handleDestinationCallback}
                                            multipleIndex={index}
                                            itemValue={(state.flightMultipleDestinationValues.length && state.flightMultipleDestinationValues[index] !== undefined) && state.flightMultipleDestinationValues[index].title}
                                        />
                                    </IonCol>
                                    <IonCol size="12">
                                        <IonLabel>
                                            تاریخ پرواز
                                            {required.multipleDate[index] ? <span className="required">الزامی</span> : null}
                                        </IonLabel>
                                        <MyDatepicker
                                            value={state.datepickerMultipleValues[index] && state.datepickerMultipleValues[index].dates[0] && new Date(state.datepickerMultipleValues[index].dates[0])}
                                            isGregorian={state.datepickerMultipleValues.isJalali === undefined ? false : state.datepickerMultipleValues.isJalali === 'true' ? false : true}
                                            isRange={false}
                                            datepickerParentCallback={handleDatepickerCallback}
                                            minDate={datepickerMinDate.current[index] && new Date(datepickerMinDate.current[index])}
                                            multipleIndex={index}
                                        />
                                    </IonCol>
                                </IonRow>
                            )}
                            <IonRow>
                                <IonCol size="12" className={state.multipleItemsCount < 5 ? '' : 'display-none'}>
                                    <IonButton color="primary" className="form-multiple-add-item-btn" onClick={addMultipleItems}>
                                        <IonIcon icon={addCircleOutline} />
                                        افزودن
                                    </IonButton>
                                </IonCol>
                                <IonCol size="12">
                                    <IonLabel>مسافران و کلاس پروازی</IonLabel>
                                    <FlightPassengerModal flightPassengerParentCallback={handlePassengerCallback} />
                                </IonCol>
                                <IonCol size="12">
                                    <IonButton color="warning" expand="block" className="form-submit-button" onClick={onSearchCLick}>
                                        جستجو
                                    </IonButton>
                                </IonCol>
                            </IonRow>
                        </div>
                    )}
                </IonCol>
            </IonRow>
        </IonGrid>
    );
};
export default Flight;